import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module.js';
import { InstallModule } from '../install/install.module.js';
import { ClientDashboardComponent } from './client-dashboard.component.js';
import { TrainerDashboardComponent } from './trainer-dashboard.component.js';

@NgModule({
	declarations: [TrainerDashboardComponent, ClientDashboardComponent],
	exports: [TrainerDashboardComponent, ClientDashboardComponent],
	imports: [CoreModule, InstallModule]
})
export class HomeModule {}
